module.exports = __webpack_public_path__ + "img/button_empower.7d88f32a.png";